import { shift_minutes } from "src/utils/datetime";
import getStore from "@utils/redux/store";
import { setUserProperties } from "@utils/redux/slices/userData";
import { appConfig } from "src/config";

// Returns length of checkout timer in minutes
export const getTimerDuration = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const checkoutTimerFromUrl = parseInt(urlParams?.get("checkoutTimer"), 10);
  if (checkoutTimerFromUrl && appConfig.NOOM_ENV !== "production") {
    return checkoutTimerFromUrl;
  }
  return 15;
};

// Checks to see that the timestamp saved in the db exists and that the current date
// is past the timestamp
export const isCheckoutTimerExpired = (
  userData = getStore().getState().userData
) => {
  const timestamp = userData.checkoutDiscountedMWCPTimerExpirationTimestamp;
  return timestamp && Date.now() >= timestamp;
};

export const trySetCheckoutTimerExpirationCookie = async () => {
  const store = getStore();
  const { userData } = store.getState();
  if (!userData.checkoutDiscountedMWCPTimerExpirationTimestamp) {
    await store.dispatch(
      setUserProperties({
        checkoutDiscountedMWCPTimerExpirationTimestamp: shift_minutes(
          getTimerDuration()
        ).getTime(),
      })
    );
  }
};

export const clearCheckoutTimerExpirationCookie = () => {
  return getStore().dispatch(
    setUserProperties({
      checkoutDiscountedMWCPTimerExpirationTimestamp: false,
    })
  );
};

export const getElapsedDuration = () => {
  const timerDuration = getTimerDuration();
  const timestamp =
    getStore().getState().userData
      .checkoutDiscountedMWCPTimerExpirationTimestamp;
  return timestamp
    ? Math.max(Math.ceil((timestamp - Date.now()) / (60 * 1000)), 0)
    : timerDuration;
};
